<script>
    import { createEventDispatcher } from 'svelte';
    import { logEvent } from './utils/logs';

    export let clickable = false;
    export let invert = false;
    export let href = '';
    /** @type {{name: string, data?: Record<string, any>} | null} */
    export let click_event = null;
    export let aria_label = '';

    let className = '';
    export { className as class };
    export let p_xl = false;
    export let p_lg = false;
    export let p_sm = false;

    /** @type {'' | 'default' | 'primary' | 'success' | 'danger'} */
    export let highlight = '';

    const dispatch = createEventDispatcher();

    /** @param {Event} e */
    const handle_click = (e) => {
        if (click_event?.name) {
            logEvent(click_event.name, click_event.data || {});
        }
        dispatch('click', e);
    };
</script>

{#if true}
    {@const padding_class = p_xl
        ? 'p-8 md:p-16'
        : p_lg
        ? 'p-6 md:px-10 md:py-8'
        : p_sm
        ? 'p-4'
        : 'p-4 md:p-6'}
    {@const surface_class =
        highlight === 'default'
            ? 'bg-surface-highlight border-border-highlight'
            : highlight === 'primary'
            ? 'bg-surface-primary-muted border-border-primary'
            : highlight === 'success'
            ? 'bg-surface-success-muted border-border-success'
            : highlight === 'danger'
            ? 'bg-surface-danger-muted border-border-danger'
            : invert
            ? 'bg-surface-invert-highlight border-border-invert-muted'
            : 'bg-surface-muted border-border-default'}
    {@const hover_class = invert
        ? 'cursor-pointer hover:bg-surface-invert-muted hover:border-border-invert-default'
        : 'cursor-pointer hover:bg-surface-default hover:border-border-default'}
    {@const base_class = `w-full flex-grow-1 border rounded-3xl overflow-hidden transition-colors duration-300 ease-out ${surface_class} ${padding_class}`}

    {#if href}
        <div
            class="link-parent relative {base_class} {hover_class} {className}"
        >
            <a
                {href}
                on:click={handle_click}
                class="absolute inset-0 rounded-3xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
                aria-label={aria_label || undefined}
            />
            <slot />
        </div>
    {:else if clickable}
        <button
            type="button"
            class="block text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset {base_class} {hover_class} {className}"
            on:click={handle_click}
        >
            <slot />
        </button>
    {:else}
        <div class="{base_class} {className}">
            <slot />
        </div>
    {/if}
{/if}
